module.exports = __webpack_public_path__ + "static/media/execute_examQuestions.61207b9f.png";